import { render, staticRenderFns } from "./Type2.vue?vue&type=template&id=c31cc44e&scoped=true"
import script from "./Type2.vue?vue&type=script&lang=js"
export * from "./Type2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31cc44e",
  null
  
)

export default component.exports